module.exports = __webpack_public_path__ + "img/Slogan_KW_RGB-transparent_hoch-1.edfd229e.png";